import { Box, Dialog, Grid, IconButton } from "@material-ui/core";
import { FC, useState } from "react";
import { RiCloseCircleFill } from "react-icons/ri";
import { ColorPicker } from "../color-picker";

import style from "./color-picker-dialogue.module.scss";

interface ColorPickerDialogProps {
  isOpen: boolean;
  onClose(): void;
  onColorSelect(color: string): void;
  selectedColor?: string;
}

const ColorPickerDialogue: FC<ColorPickerDialogProps> = ({
  isOpen,
  onClose,
  ...rest
}) => {
  const [showPicker, setShowPicker] = useState(false);

  return (
    <Dialog
      open={isOpen}
      classes={{
        paper: style.paper,
        root: style.root,
      }}
    >
      <Grid container xs={12} sm={8} className={style.dheader}>
        <IconButton onClick={onClose}>
          <RiCloseCircleFill size="30px" />
        </IconButton>
      </Grid>
      <Grid
        container
        xs={12}
        sm={8}
        style={{ margin: 0, padding: ".5em 1em" }}
        spacing={3}
        justifyContent="center"
        className={style.wrapper}
      >
        <ColorPicker
          showPicker={showPicker}
          setShowPicker={setShowPicker}
          {...rest}
        />
      </Grid>
    </Dialog>
  );
};

export default ColorPickerDialogue;
